import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { colorStack } from '../../../styleHelpers/colors';
import { IItem } from '../../../entities/IFilters';
import { AllStatusEnums, EProfileType } from '../../../entities/IGlobal';
import { Avatar, EAvatarSize } from '../Avatar/Avatar';
import { getStatusText } from '../../../tools/statusHelper';
import { Checkbox } from '../Inputs/Checkbox';
import { RadioButton } from '../Inputs/RadioButton';
import { MultilineTextWithEllipsis } from '../TextWithEllipsis/MultilineTextWithEllipsis';
import IntlMessage, { useIntlMessage } from '../IntlMessage';
import { StatusDot } from '../StatusDot/StatusDot';
import { ApprovalStatusMapper, EApprovalStatus } from '../../../entities/IStatus';

const SingleElem = styled.div<{ active?: boolean }>`
    font-weight: ${({ active }) => active ? 500 : 400};
    padding: 12px 1rem;
    min-height: 46px;
    justify-content: space-between;
    background: ${colorStack.white};
    transition: all .3s;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    &:hover {
        background: ${colorStack.lightBlue};
    }
    ${props => props.active && css`
        background: ${colorStack.lightBlue};
    `}
    > div:first-child {
        width: calc(100% - .5rem - 34px);
    }
    > div:nth-child(2) {
        width: calc(100% - 35px);
    }
`;

const ShadowLayer = styled.div`
    width: 97%!important;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
`;

export interface ISingleResultElement {
    elem: IItem;
    active?: boolean;
    type: string;
    translationKey?: string;
    multiSelect?: boolean;
    selectItem(elem: IItem): void;
}

export const SingleResultElement: FC<React.PropsWithChildren<ISingleResultElement>> = props => {
    const { intlFormatMessage } = useIntlMessage();

    const selectItem = (e?: React.MouseEvent<HTMLDivElement>) => {
        e?.stopPropagation();
        e?.preventDefault();
        props.selectItem({
            ...props.elem, text: props.type === 'status' ? getStatusText(props.elem.text as AllStatusEnums, intlFormatMessage) : props.elem.text
        });
    };

    return (
        <SingleElem key={props.elem.id} active={props.active}>
            <ShadowLayer onClick={selectItem} />
            {(props.type === EProfileType.Personal || props.type === EProfileType.LegalEntity || props.type === EProfileType.Group || props.type === EProfileType.Cluster) &&
                <Avatar
                    extended
                    firstName={props.elem.text}
                    lastName=""
                    type={props.type as EProfileType}
                    id={props.elem.id}
                    metaInfo={props.elem.data?.emailContact}
                    size={EAvatarSize.SMALL}
                    picture={props.elem.data.picture}
                    preventRedirection
                />
            }
            {props.type === 'default' &&
                <MultilineTextWithEllipsis numberOfLines={2}>
                    {props.translationKey ? <IntlMessage id={`${props.translationKey}.${props.elem.data.key || props.elem.data}`} /> : props.elem.text}
                </MultilineTextWithEllipsis>
            }
            {props.type === 'status' &&
                <StatusDot<EApprovalStatus>
                    mapper={ApprovalStatusMapper}
                    status={props.elem.text as EApprovalStatus}
                    extended
                    size={16}
                />
            }
            {props.multiSelect ? (
                <Checkbox checked={props.active} />
            ) : (
                <RadioButton checked={props.active} />
            )}
        </SingleElem>
    );
};
